import React, { useRef } from "react";

/**
 * Button that opens a file dialog when clicked.
 * @param {object} props
 * @param {(file: File) => void} props.onUpload Called when a file is uploaded.
 * @param {React.ReactNode} props.children Content for the button (e.g., the button text).
 */
function FileUploadButton({ onUpload, children }) {
    const fileInputRef = useRef(null);

    /**
     * Clicks the hidden input element.
     */
    function handleClick() {
        fileInputRef.current?.click();
    }

    /**
     * Called when a file is selected in the Windows file dialog.
     * @note This function won't be called if the dialog is cancelled.
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function handleFileSelected(event) {
        const file = event.target.files[0];

        if (file) {
            onUpload(file);
        }

        // Need to clear the value so that this event can fire again
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    return (
        <>
            <input ref={fileInputRef} type="file" style={{ display: "none" }} onInput={handleFileSelected} />
            <button type="button" onClick={handleClick} className="btn-primary btn-xs">
                {children}
            </button>
        </>
    );
}

export default FileUploadButton;
